import type { LocationType } from '@sdk/locations/types/LocationType';

export const getMappedLocations = (locations: LocationType[]): LocationType[] =>
  locations?.map((location) => ({
    activeMembers: location.activeMembers,
    activeMemberCount: location.activeMemberCount,
    address: location.address,
    archivedAt: location.archivedAt,
    budget: location.budget,
    coordinates: location.coordinates,
    displayName: location.displayName,
    hiddenOnSchedule: location.hiddenOnSchedule,
    hoursCap: location.hoursCap,
    id: location.id,
    ipAddresses: location.ipAddresses,
    mapCenter: location.mapCenter,
    memberCount: location.memberCount,
    members: location.members,
    name: location.name,
    phone: location.phone,
    timezone: location.timezone,
    type: location.type,
  }));
